import React from 'react';
import { Container, Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { MarkdownView } from '../components/MarkdownRenderer';
import SEO from '../components/SEO';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div style={{ 
      minHeight: 'calc(100vh - 120px)', 
      backgroundColor: 'var(--bg-color)',
      color: 'var(--text-color)',
      transition: 'background-color 0.3s ease, color 0.3s ease',
      padding: '20px 0'
    }}>
      <SEO
        title="Privacy Policy - Osailu"
        description="Learn how Osailu protects your privacy and handles your personal information. Read our comprehensive privacy policy for our virtual learning automation platform."
        keywords="Osailu privacy policy, data protection, privacy, user data, GDPR"
        url="/privacy"
      />
      <Container className="mt-4 mb-5">
      <div className="d-flex justify-content-between align-items-center mb-4">
        {/* Title is inside the markdown document */}
        <Button variant="outline-secondary" onClick={() => navigate(-1)}>
          ← Back
        </Button>
      </div>

      <Card>
        <Card.Body>
          <div className="page-content">
          <MarkdownView path="/PRIVACY_POLICY.md" />
        </div>
        </Card.Body>
      </Card>
    </Container>
    </div>
  );
};

export default PrivacyPolicy;
